export function buildSlotOperations({
	originalFreeSlots,
	currentFreeSlots,
	removedSlotIds,
	newSlots,
}: {
	originalFreeSlots: Array<{ id: string; name: string }>
	currentFreeSlots: Array<{ id: string; name: string }>
	removedSlotIds: string[]
	newSlots: Array<{ name: string }>
}) {
	const originalNameById = new Map(
		originalFreeSlots.map((s) => [s.id, s.name]),
	)
	const removedSet = new Set(removedSlotIds)

	const renameSlots = currentFreeSlots
		.filter((s) => {
			if (removedSet.has(s.id)) return false
			const original = originalNameById.get(s.id)
			const trimmed = s.name.trim()
			return Boolean(trimmed) && original !== undefined && trimmed !== original
		})
		.map((s) => ({
			id: s.id,
			name: s.name.trim(),
		}))

	const addNames = newSlots
		.map((s) => s.name.trim())
		.filter(Boolean)

	return {
		addNames,
		renameSlots,
		removeSlotIds: removedSlotIds,
	}
}
